export enum BankEnum {
  TINKOFF = 'TINKOFF',
  SBERBANK = 'SBERBANK',
  ALFA = 'ALFA'
}
